import React, { Component } from "react";
import { Container, Divider, Grid } from "semantic-ui-react";
import title from "../../static/converted/title_luftaufnahme_wallerwelt-min.jpg";
// import camp from '../../static/oberlauf_camp_title.jpg'
// import kran from "../../static/converted/oberlauf_kran-min.jpg";

import Imgmodal from "../imgmodal";

export default class Einleitung extends Component {
  render() {
    return (
      <Container id="einleitung">
        <h1>
          <a href="/#Mittellauf">
            Waller-Welt am Po-Mittellauf / Borgoforte bei Mantova
          </a>
        </h1>
        <Imgmodal img={title} />
        <p>
          Mit mehr als 30.000 qm ist die Waller-Welt das größte
          Privat-Grundstück mit direktem Wasserzugang am Fluss Po.
        </p>
        <p>
          Der Mittellauf des Po ist bereits seit den 90er Jahren als DAS
          Welsgewässer in Europa bekannt.
        </p>
        <p>
          Neben dem Klima tragen auch die Meeräschen welche sich im
          Frühjahr/Sommer im Fluss befinden als unerschöpfliche
          Nahrungsquelle dazu bei, dass die Welse hier eine Rekordgröße
          erreichen.
        </p>
        <div className="responsive_map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2818.8921708090616!2d10.75192131594015!3d45.04740997909816!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47802ba29c016201%3A0x649636918685d6e8!2sWaller-+Welt+SRL!5e0!3m2!1sde!2sde!4v1523632399876"
            width="300"
            height="600"
            frameBorder="0"
            allowFullScreen
          />
        </div>
        <h1>Dein Erfolg ist unser Ziel!!!</h1>
        <p>
          Mit einer überdurchschnittlichen Anzahl an Fischen pro Saison haben
          wir eine für Italien außergewöhnlich hohe Fangrate. Wir sprechen hier
          von 250 und mehr Fischen, welche die Länge von 2m überschreiten.
          Unsere Guides, zählen zu den besten und erfolgreichsten Wels-Anglern
          in ganz Europa und sind täglich für und mit Euch am Wasser unterwegs.
        </p>
        <p>
          Das Revier erstreckt sich auf über 130 Kilometer atemberaubender
          Flusslandschaft.
        </p>
        <p>
          Mit den führerscheinfreien Leihbooten erreicht Ihr Geschwindigkeiten
          von über 50 km/h. Große Strecken sind damit schnell zurückgelegt.
        </p>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Einleitung/index.js